import { render } from "./NoGroupNotice.vue?vue&type=template&id=06826e9c"
const script = {}

import "./NoGroupNotice.vue?vue&type=style&index=0&id=06826e9c&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__